import { http } from "../../../config/HttpMethod";
import {
    ChargePumpData,
    FetchEquipmentsForHanderPayload,
    GKXPumpCalculationInputs,
    GKXPumpChangeOutput,
    SpecialPumpCalculationOutput,
} from "../../../store/model/calculations/calculation";
import { ESP_ENDPOINTS } from "../endpoints";


export const fetchEquipmentsForHandler = async (
    payload: FetchEquipmentsForHanderPayload
) => {
    const params = payload;
    try {
        const response = await http.get(
            `${ESP_ENDPOINTS?.GET_SR_GAS_HANDLERS}`,
            {
                params,
            }
        );
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGKXCalculations = async (payload: object) => {
    try {
        const response = await http.post<ChargePumpData>(`${ESP_ENDPOINTS?.GET_GKX_CALCULATIONS}`, payload);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasCalculationOnGKXPumpChange = async (inputs: GKXPumpCalculationInputs) => {
    try {
        const response = await http.post<GKXPumpChangeOutput>(`${ESP_ENDPOINTS?.GET_GKX_PUMP_CHANGE}`, inputs);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasHandlerData = async (postInputSepData: object) => {
    try {
        const response = await http.post<SpecialPumpCalculationOutput>(`${ESP_ENDPOINTS?.GET_SPECIAL_PUMP_CALCULATIONS}`, postInputSepData);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};
